import { render, staticRenderFns } from "./WorkflowMaintenanceNew.vue?vue&type=template&id=31b153b1"
import script from "./WorkflowMaintenanceNew.vue?vue&type=script&lang=js"
export * from "./WorkflowMaintenanceNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports